module.exports = __webpack_public_path__ + "img/pizza.38577567.jpeg";